import { api } from '../../lib/api';

export interface CashSummaryDTO {
  openingFloat: number;
  cashSales: number;
  cashIn: number;
  cashOut: number;
  expected: number;
  counted: number | null;
  difference: number | null;
  invoiceCount: number;
  paymentBreakdown: Array<{ method: string; amount: number; count: number }>;
}

export interface CurrentDrawerDTO {
  id: number;
  openedAt: string;
  openingFloat: number;
  movements: Array<{
    id: number;
    kind: 'CASH_IN' | 'CASH_OUT';
    amount: number;
    reason: string;
    createdAt: string;
  }>;
  summary: CashSummaryDTO;
}

export interface DrawerHistoryDTO {
  id: number;
  openedAt: string;
  closedAt: string | null;
  openingFloat: string;
  countedCash: string | null;
  expectedCash: string | null;
  difference: string | null;
  openedByName: string;
  closedByName: string | null;
  notes: string | null;
}

export async function getCurrentDrawer(): Promise<CurrentDrawerDTO | null> {
  const { data } = await api.get<CurrentDrawerDTO | null>('/api/cash-drawer/current');
  return data;
}

export async function openDrawer(openingFloat: number): Promise<{ id: number }> {
  const { data } = await api.post<{ id: number }>('/api/cash-drawer/open', { openingFloat });
  return data;
}

export async function addMovement(
  drawerId: number,
  body: { kind: 'CASH_IN' | 'CASH_OUT'; amount: number; reason: string },
): Promise<void> {
  await api.post(`/api/cash-drawer/${drawerId}/movement`, body);
}

export async function closeDrawer(
  drawerId: number,
  body: { countedCash: number; notes?: string },
): Promise<{ summary: CashSummaryDTO }> {
  const { data } = await api.post<{ summary: CashSummaryDTO }>(`/api/cash-drawer/${drawerId}/close`, body);
  return data;
}

export async function listDrawerHistory(): Promise<DrawerHistoryDTO[]> {
  const { data } = await api.get<DrawerHistoryDTO[]>('/api/cash-drawer/history');
  return data;
}
